import workspaceQuery from 'graphql/queries/customer/CreditAgencyWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/customer/CreditAgencyListQuery.graphql';
import instanceQuery from 'graphql/queries/customer/CreditAgencyQuery.graphql';
import defaultQuery from 'graphql/queries/customer/CreditAgencyDefault.graphql';
import mutationQuery from 'graphql/mutations/customer/CreditAgencyMutation.graphql';
import fragment from 'graphql/fragments/customer/CreditAgencyFragment.graphql';

const CreditAgency = {
  type: 'CreditAgency',
  title: 'Credit Agencies',
  formUrl: '/Customers/CreditAgency/Details/',
  formTitle: 'Credit Agencies',
  workspaceUrl: '/Customers/CreditAgency/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'CUSTOMER_CREDIT_AGENCY',
};

export default CreditAgency;
